import common from "@page/common/js/common";
import Mag from "../components/Mag.vue";

// 小雜誌首頁
new Vue({
	el: "#mag-index",
	template: `<div><Mag/></div>`,
	components: { Mag },
});
